<template>
  <div class="loading">
    <loading-progress
      :progress="progress"
      :indeterminate="indeterminate"
      :counter-clockwise="counterClockwise"
      :hide-background="hideBackground"
      size="64"
      rotate
      fill-duration="2"
      rotation-duration="1"
    />
  </div>
</template>

<script>
export default {
  name: "Loading",
  data: function() {
    return {
      progress: 0, // 0 ~ 0.5 ~ 1
      indeterminate: false, // 自動
      counterClockwise: false, // プログレスの反転
      hideBackground: false //背景の非表示
    }
  }
}
</script>

<style scoped>
.loading {
  position: fixed;
  z-index: 5000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.2s;
  background: #e3e3e3;
}

.vue-progress-path {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}

.vue-progress-path path {
  stroke-width: 12;
}
</style>
